import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import customIsoString from 'utilities/custom-iso-string';
import './AgendaItem.module.scss';


//import components

//import Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//import actions
import { homeworkDate } from 'actions/new-homework';

const mapStateToProps = (state, props) => {
    return {

    };
};

const mapDispatchToProps = {
    homeworkDate,
};

class AgendaItem extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };

        this.handlePlanClick = this.handlePlanClick.bind(this);

    }

    handlePlanClick() {
        let date = customIsoString(this.props.date).split('T')[0];
        this.props.homeworkDate(date);
        this.props.handleClick();
    }

    render() {
        let items = this.props.items.sort((a,b) => parseInt(a.start_at)-parseInt(b.start_at));
        let timelessItems = this.props.items.filter((item) => item.timeslot == 99 && !item.start_at);
        let planned = items.length > 0;
        let amount = items.length;
        
        timelessItems.map(timelessItem => {
            items.unshift(timelessItem);
        });

        return (
            <div style={this.props.draggingASchedule ? {background: 'rgba(0, 0, 0, 0.02)'} : {}} styleName={this.props.weekend ? `agenda-item-wrapper ${planned ? 'planned' : ''} weekend` : `agenda-item-wrapper ${planned ? 'planned' : ''}`} onClick={!planned ? this.handlePlanClick : undefined}>
                { planned &&  
                <Fragment>
                    <div styleName='item-wrapper' onClick={planned ? this.handlePlanClick : undefined}>
                        <div styleName='item-details'>
                            <div styleName='text'>
                                <p styleName='subject'>{items[0].description}{(items[0].note || items[0].image) && <FontAwesomeIcon icon={[ 'fal','paperclip' ]} style={{ marginLeft: '2px' }}/>}</p>

                                {amount > 2 ? <p styleName='subject'><b>{`+ ${amount - 1} items`}</b></p> : <p styleName='subject'>{amount > 1 ? items[1].description : ''}{amount > 1 && ((items[1].note || items[1].image) && <FontAwesomeIcon icon={[ 'fal','paperclip' ]} style={{ marginLeft: '2px' }}/>)}</p>}
                            
                            </div>
                            <div styleName='time' 
                                // style={amount > 1 ? { justifyContent: 'flex-start' } : { justifyContent: 'center' }}
                                style = {
                                    {
                                        'justifyContent': amount > 1 ? 'flex-start' : 'center',
                                        'margin': amount > 2 ? '2px 0 auto 0' : '0'
                                    }
                                }
                            >
                                {items[0].start_at ? <p styleName='value'><b>{items[0].start_at} - {items[0].end_at}</b></p> : <p styleName='value empty'></p>}
                                { amount <= 2 && items[1] && items[1].start_at && <p styleName='value'><b>{amount > 1 ? `${items[1].start_at} - ${items[1].end_at}` :''}</b></p>}
                            </div>
                        </div>
                        <div styleName='line'/>
                    </div>
                    <FontAwesomeIcon styleName='icon' icon={[ 'fal', 'plus' ]} onClick={() => this.props.handleAgendaInputClick()}/>
                </Fragment>
                }
                
            </div>
        );
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(AgendaItem);